<template>
  <breadCrumbs title="Knowledgebase" main="Knowledgebase" title1="Knowledgebase Category" />
  <div class="container-fluid faq-section">
    <div class="row">
      <div class="col-12">
        <div class="knowledgebase-bg"><img class="bg-img-cover bg-center" src="@/assets/images/knowledgebase/bg_1.jpg"
            alt="Background Image1"></div>
        <div class="knowledgebase-search">
          <div>
            <h3>How Can I help you?</h3>
            <form class="form-inline" action="#" method="get">
              <div class="form-group w-100 mb-0"><vue-feather type="search"></vue-feather>
                <input class="form-control-plaintext w-100" type="text" placeholder="Type question here" title="">
              </div>
            </form>
          </div>
        </div>
      </div>
      <faqWidgets />
      <div class="col-sm-12">
        <div class="header-faq">
          <h5 class="mb-0">knowledge articles by category</h5>
        </div>
        <div class="row browse">
          <div class="col-xl-4 xl-33 col-md-6 box-col-33" v-for="index in data" :key="index">
            <div class="browse-articles">
              <h3><span><vue-feather type="file-text"></vue-feather></span>{{ index }}</h3>
              <ul>
                <li><router-link to="/knowledgebase/detail">
                    <h5><vue-feather type="file-text"></vue-feather>Policies have wide acceptance among editors</h5>
                  </router-link></li>
                <li><router-link to="/knowledgebase/detail">
                    <h5><vue-feather type="file-text"> </vue-feather>Guidelines are sets of best practices supported.</h5>
                  </router-link></li>
                <li><router-link to="/knowledgebase/detail">
                    <h5><vue-feather type="file-text"></vue-feather>Editors should attempt to follow guidelines.</h5>
                  </router-link></li>
                <li><router-link to="/knowledgebase/detail">
                    <h5><vue-feather type="file-text"></vue-feather>They are best treated with common sense.</h5>
                  </router-link></li>
                <li><router-link class="f-w-600 font-primary" to="/knowledgebase/detail"><vue-feather class="me-1"
                      type="arrow-right"></vue-feather><span>See More (40)</span></router-link></li>
              </ul>
            </div>
          </div>

          <div class="col-xl-4 xl-33 col-md-6 box-col-33">
            <div class="browse-articles browse-bottom">
              <h3><span><vue-feather type="archive"></vue-feather></span>What is Lorem Ipsum?</h3>
              <ul>
                <li><router-link to="/knowledgebase/detail">
                    <h5><vue-feather type="file-text"></vue-feather>Common language regular than the existing languages.
                    </h5>
                  </router-link></li>
                <li><router-link to="/knowledgebase/detail">
                    <h5><vue-feather type="file-text"></vue-feather>Lorem Ipsum has been the industry's standard dummy
                    </h5>
                  </router-link></li>
                <li><router-link to="/knowledgebase/detail">
                    <h5><vue-feather type="file-text"></vue-feather>Language is not real even ‘Lorem’ does't exist.</h5>
                  </router-link></li>
                <li><router-link to="/knowledgebase/detail">
                    <h5><vue-feather type="file-text"></vue-feather>dummy text that is not meant to mean anything.</h5>
                  </router-link></li>
                <li><router-link class="f-w-600 font-primary" to="/knowledgebase/detail"> <vue-feather class="me-1"
                      type="arrow-right"></vue-feather><span>See More (34)</span></router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import faqWidgets from "./faqWidgets.vue"
export default {
  components: { faqWidgets },
  data() {
    return {
      data: ['Any other legal pages I should know about?', 'Does Moment have an API or automatic export?', 'How do WordPress Site Maintenance', 'Can I change my plan later?', 'How do I pay for the Premium Plan?', 'What is your Shopping Policy', 'How can I change the component?', 'How does it work?']
    }
  }
}
</script>